import types from '../mutation-types';
import ScheduledMessagesAPI from '../../api/scheduledMessages';

const byTime = (r1, r2) =>
  new Date(r1.scheduled_at) - new Date(r2.scheduled_at);

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getByConversation: _state => conversationId =>
    [...(_state.records[conversationId] || [])].sort(byTime),
  getUIFlags: _state => _state.uiFlags,
};

export const actions = {
  async fetch({ commit }, { conversationId }) {
    commit(types.SET_SCHEDULED_MESSAGES_UI_FLAG, { isFetching: true });
    try {
      const { data } = await ScheduledMessagesAPI.get(conversationId);
      commit(types.SET_SCHEDULED_MESSAGES, { conversationId, data });
    } finally {
      commit(types.SET_SCHEDULED_MESSAGES_UI_FLAG, { isFetching: false });
    }
  },
  async create({ commit }, { conversationId, payload }) {
    commit(types.SET_SCHEDULED_MESSAGES_UI_FLAG, { isCreating: true });
    try {
      const { data } = await ScheduledMessagesAPI.create(
        conversationId,
        payload
      );
      commit(types.ADD_SCHEDULED_MESSAGE, { conversationId, data });
      return data;
    } finally {
      commit(types.SET_SCHEDULED_MESSAGES_UI_FLAG, { isCreating: false });
    }
  },
  async createSequence({ commit }, { conversationId, payload }) {
    commit(types.SET_SCHEDULED_MESSAGES_UI_FLAG, { isCreating: true });
    try {
      const { data } = await ScheduledMessagesAPI.createSequence(
        conversationId,
        payload
      );
      (data.records || []).forEach(record => {
        commit(types.ADD_SCHEDULED_MESSAGE, { conversationId, data: record });
      });
      return data;
    } finally {
      commit(types.SET_SCHEDULED_MESSAGES_UI_FLAG, { isCreating: false });
    }
  },
  async update({ commit }, { conversationId, id, payload }) {
    commit(types.SET_SCHEDULED_MESSAGES_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await ScheduledMessagesAPI.update(
        conversationId,
        id,
        payload
      );
      commit(types.ADD_SCHEDULED_MESSAGE, { conversationId, data });
      return data;
    } finally {
      commit(types.SET_SCHEDULED_MESSAGES_UI_FLAG, { isUpdating: false });
    }
  },
  async remove({ commit }, { conversationId, id }) {
    commit(types.SET_SCHEDULED_MESSAGES_UI_FLAG, { isDeleting: true });
    try {
      await ScheduledMessagesAPI.delete(conversationId, id);
      commit(types.DELETE_SCHEDULED_MESSAGE, { conversationId, id });
    } finally {
      commit(types.SET_SCHEDULED_MESSAGES_UI_FLAG, { isDeleting: false });
    }
  },
  removeLocal({ commit }, { conversationId, id }) {
    commit(types.DELETE_SCHEDULED_MESSAGE, { conversationId, id });
  },
  async removeSequence({ commit }, { conversationId, sequenceId }) {
    commit(types.SET_SCHEDULED_MESSAGES_UI_FLAG, { isDeleting: true });
    try {
      await ScheduledMessagesAPI.deleteSequence(conversationId, sequenceId);
      commit(types.DELETE_SCHEDULED_SEQUENCE, { conversationId, sequenceId });
    } finally {
      commit(types.SET_SCHEDULED_MESSAGES_UI_FLAG, { isDeleting: false });
    }
  },
  // Sequência já foi interrompida no servidor (resposta do cliente); só limpa a faixa local.
  removeSequenceLocal({ commit }, { conversationId, sequenceId }) {
    commit(types.DELETE_SCHEDULED_SEQUENCE, { conversationId, sequenceId });
  },
};

export const mutations = {
  [types.SET_SCHEDULED_MESSAGES_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_SCHEDULED_MESSAGES](_state, { conversationId, data }) {
    _state.records = { ..._state.records, [conversationId]: data };
  },
  [types.ADD_SCHEDULED_MESSAGE](_state, { conversationId, data }) {
    const current = (_state.records[conversationId] || []).filter(
      r => r.id !== data.id
    );
    _state.records = {
      ..._state.records,
      [conversationId]: [...current, data],
    };
  },
  [types.DELETE_SCHEDULED_MESSAGE](_state, { conversationId, id }) {
    const current = (_state.records[conversationId] || []).filter(
      r => r.id !== id
    );
    _state.records = { ..._state.records, [conversationId]: current };
  },
  [types.DELETE_SCHEDULED_SEQUENCE](_state, { conversationId, sequenceId }) {
    const current = (_state.records[conversationId] || []).filter(
      r => r.content_attributes?.sequence_id !== sequenceId
    );
    _state.records = { ..._state.records, [conversationId]: current };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
